var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-plyr',[_c('video',{attrs:{"playsinline":"","controls":"","data-poster":_vm.poster}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.type}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }